// src/config/environment.js
export const mockUser = {
  username: "adrianasouza77@hotmail.com",
  password: "123456@ovit",
  displayName: "Administrador",
  uid: "sofia",
  photoURL: "https://ui-avatars.com/api/?name=Admin"
};